import React, { PropsWithChildren, useEffect, useState } from 'react'

import { Grid, IconButton, Paper, Theme } from '@mui/material'
import { makeStyles } from '@mui/styles'
import CancelRounded from '@mui/icons-material/CancelRounded'
import VideoPost from '@professocial/professocialPosting/src/shared/components/ModuleComponents/Post/modules/VideoPost'
import { ViewEnum } from '@professocial/professocialTypes/types/commonTypes'

interface IProps extends PropsWithChildren{
  src?: string | undefined
  videoSrc?: string
  alt?: string
  disabled?: boolean
  payload?: string | React.ReactElement
  Wrapper?: React.ComponentType<any>
  isOpenParent?: boolean
  setOpenParent?: React.Dispatch<React.SetStateAction<boolean>>
}

const useStyles = makeStyles((theme: Theme) => ({
  container: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    position: 'fixed',
    top: 0,
    left: '0',
    height: '100vh',
    width: '100vw',
    backgroundColor: 'rgba(0,0,0,0.2)',
    cursor: 'pointer',
    zIndex: 100,
    [theme.breakpoints.up('md')]: {
      top: 0,
      height: '100vh',
    },
  },
  paper: {
    width: '100%',
    padding: theme.spacing(5),
  },
  wrapper: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
  },
  image: {
    maxHeight: '75vh',
    maxWidth: '90vw',
    [theme.breakpoints.up('md')]: {
      maxHeight: '85vh',
    },
  },
  grid: {
    width: '90vw',
    maxWidth: '1100px',
    height: '75vh',
    maxHeight: '620px',
    [theme.breakpoints.up('md')]: {
      height: '85vh',
    },
  },
  closeIcon: {
    alignSelf: 'flex-end',
    color: '#fff',
    marginRight: '-30px',
  },
  embedResponsive: {
    position: 'relative',
    display: 'block',
    width: '90vw',
    padding: '56.25% 0 0 0',
    overflow: 'hidden',
    [theme.breakpoints.up('md')]: {
      width: '60vw',
    },
  },
  embedResponsiveItem: {
    position: 'absolute',
    top: 0,
    bottom: 0,
    left: 0,
    width: '100%',
    height: '100%',
    border: 0,
  },
  disabled: {
    pointerEvents: 'none',
  },
}))

const LightBox: React.FC<IProps> = (props) => {
  const {
    isOpenParent,
    setOpenParent,
    payload,
    src,
    children,
    videoSrc,
    alt,
  } = props

  const [isOpen, setIsOpen] = useState(false)

  const classes = useStyles()

  useEffect(() => {
    setOpenParent && setIsOpen(false)
  }, [isOpenParent])

  const toggleIsOpen = (event: React.MouseEvent<HTMLDivElement, MouseEvent>) => {
    setIsOpen(!isOpen)
  }

  return (
    <div className={props.disabled ? classes.disabled : undefined} onClick={toggleIsOpen}>
      {children}
      {isOpen ? (
        <>
          <div className={classes.container}>
            <div className={classes.wrapper}>
              <IconButton
                className={`${classes.closeIcon}`}
                color='default'
                component='div'
                onClick={toggleIsOpen}
                size='large'
              >
                <CancelRounded />
              </IconButton>
              {src && !videoSrc &&
                <img
                  src={src}
                  alt={alt}
                  className={classes.image}
                  onClick={(e) => e.stopPropagation()}
                />}
              {videoSrc && <VideoPost value={{ previewImageUrl: src, url: videoSrc }} view={ViewEnum.preview} />}
              {payload && (
                <>
                  <Grid container className={classes.grid} onClick={(e) => e.stopPropagation()}>
                    <Grid item xs={12}>
                      <Paper className={classes.paper}>
                        {payload}
                      </Paper>
                    </Grid>
                  </Grid>
                </>)}
            </div>
          </div>
        </>) : null}
    </div>
  )
}

export default LightBox
